import React from "react";
import { Link } from "react-router-dom";
import "./DRM_Summary.css";
import { FaPlusCircle } from "react-icons/fa";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ModalPopup from "../Common/ModalPopup";
import { Message, Loader } from "../../features/shared";
import CommonSnackbar from "../Common/CommonSnackbar";
import { getRejectFeedback } from "../../services/DRM/getRejectFeedback";
import { getMeetingDetails } from "../../services/DRM/getMeetingDetails";
import { format, parseISO, parse } from "date-fns";

const DRMSummary = ({
  meetingsummary,
  noMeeting,
  loading,
  feedbackloading,
  setfeedbackLoading,
  setLoading,
  failedOpen,
  setFailesOpen,
  handleOnClose,
  snackerror,
  setSnackError,
}) => {
  const userType = useSelector((state) => state?.userType?.type != "Other" ? state?.userType?.type : state?.userDetails?.details?.Title);
  const [show, setShow] = useState(false);

  const [feedback, setFeedback] = useState([]);
  const [zsmfeedback, setZSMFeedback] = useState([]);
  const [tmmfeedback, setTMMFeedback] = useState([]);
  const meetings = [
    { id: "0001", date: "01-05-2024", status: "Approved" },
    { id: "0002", date: "05-05-2024", status: "Rejected" },
  ];
  const sortedMeetingsummary = [...meetingsummary].sort(
    (a, b) =>
      new Date(b.Actual_Date_of_the_Meet__c) -
      new Date(a.Actual_Date_of_the_Meet__c)
  );

  const handleClose = () => setShow(false);

  const handleShow = async (index) => {
    try {
      const currentmeetingid = sortedMeetingsummary[index]?.Id;
      setfeedbackLoading(true);
      const response = await getRejectFeedback({ currentmeetingid });

      if (response?.success) {
        /////// format 2024-06-20  to 20 jun /////////////
        // const formatDateToDayMonth = (dateStr) => {
        //   const date = parseISO(dateStr);
        //   return format(date, 'dd MMM');

        // }
        const formatDateToDayMonth = (dateStr) => {
          const date = parse(dateStr, "d/M/yyyy", new Date());
          return format(date, "dd MMM");
        };

        console.log('response?.data', response?.data);
        
       

        const formattedData = response?.data?.map((item) => ({
          ...item,
          NSM: {
            ...item?.NSM,
            NSM_Rejected_Date__c: item?.NSM.NSM_Rejected_Date__c
              ? formatDateToDayMonth(item.NSM.NSM_Rejected_Date__c)
              : "",
          },
          TMM: {
            ...item?.TMM,
          },
          ZSM: {
            ...item?.ZSM,
            ZSM_Rejected_Date__c: item?.ZSM.ZSM_Rejected_Date__c
              ? formatDateToDayMonth(item.ZSM.ZSM_Rejected_Date__c)
              : "",
          },
        }));

        console.log('formattedData', formattedData);
        
        const NSMFeedback = [];
        const ZSMFeedback = [];
        const TMMFeedback = [];
        formattedData?.forEach((data, idx) => {
          if (data?.NSM?.NSM_Feedback__c) {
            NSMFeedback.push({
              key: data?.NSM?.NSM_Rejected_Date__c,
              value: data?.NSM?.NSM_Feedback__c,
            });
          }
        });
        formattedData?.forEach((data, idx) => {
          if (data?.ZSM?.ZSM_Feedback__c) {
            ZSMFeedback.push({
              key: data?.ZSM?.ZSM_Rejected_Date__c,
              value: data?.ZSM?.ZSM_Feedback__c,
            });
          }
        });
        formattedData?.forEach((data, idx) => {
          if (data?.TMM?.TMM_Feedback__c) {
            TMMFeedback.push({
              key: data?.TMM?.TMM_Feedback__c,
              value: data?.TMM?.TMM_Feedback__c,
            });
          }
        });
        setFeedback(NSMFeedback);
        setZSMFeedback(ZSMFeedback);
        setTMMFeedback(TMMFeedback);
        setShow(true);
        setfeedbackLoading(false);
      } else {
        setSnackError(response?.msg);
        setfeedbackLoading(false);
        setFailesOpen(true);
      }
    } catch (error) {
      console.error("Error fetching Feedback:", error);
      setfeedbackLoading(false);
    }
  };

  console.log("sortedMeetingsummary==>", sortedMeetingsummary);
  return (
    <div className="drm-summary">
      <CommonSnackbar
        open={failedOpen}
        autoHideDuration={7000}
        onClose={handleOnClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        severity={"error"}
        message={snackerror}
      />
      {/* <h2>DRM Summary</h2> */}
      <Loader loading={loading} />
      <Loader loading={feedbackloading} />
      {!loading &&
        (sortedMeetingsummary?.length === 0 ? (
          <Message
            message={
              "No DRM Planned Till Now. Click on the + icon to create new meeting"
            }
            className={"tourPlan__messageConatiner"}
          />
        ) : (
          <table className="drm-table">
            <thead>
              <tr>
                <th>Meeting Code</th>
                <th>Meeting Date</th>
                <th>Status</th>
                <th>Feedback</th>
              </tr>
            </thead>
            <tbody className="summary_Drm">
              {sortedMeetingsummary.map((meeting, index) => {
                const ZSM = meeting?.ZSM_Status__c;
                const NSM = meeting?.NSM_Status__c;
                const TMM = meeting?.TMM_Status__c;

                return (
                  <tr key={meeting.Id}>
                    <td className="meetingID">
                      <Link to={`/DRMplanning?id=${meeting.Id}`}>
                        {meeting.Id}
                      </Link>
                    </td>

                    <td className="DateOfMeet">
                      {meeting?.Actual_Date_of_the_Meet__c}
                    </td>

                    {/* ---------- STATUS COLUMN ---------- */}
                    <td>
                      {(() => {
                        // Normalize null to "Pending"
                        const zsm = ZSM || "Pending";
                        const tmm = TMM || "Pending";
                        const nsm = NSM || "Pending";

                        // Show status based on logged-in user type
                        // TMM users see NSM stage
                        if (userType === "TMM") {
                          if (nsm === "Pending")
                            return (
                              <span className="status-pending">
                                Pending (NSM)
                              </span>
                            );
                          if (nsm === "Rejected")
                            return (
                              <span className="status-rejected">
                                Rework (NSM)
                              </span>
                            );
                          if (nsm === "Approved" || nsm === "Completed")
                            return (
                              <span className="status-approved">
                                {nsm === "Completed" ? "Completed" : "Approved"}
                              </span>
                            );
                        }

                        // Default: show all stages (for BM/SH3, ZSM/SH5/SH6, and others)
                        // 1️⃣ ZSM Stage
                        if (zsm === "Pending") {
                          // ZSM creates meetings — they skip their own approval stage
                          if (userType === "SH5" || userType === "SH6")
                            return (
                              <span className="status-pending">
                                Pending (TMM)
                              </span>
                            );
                          return (
                            <span className="status-pending">
                              Pending (ZSM)
                            </span>
                          );
                        }
                        if (zsm === "Rejected")
                          return (
                            <span className="status-rejected">
                              Rework (ZSM)
                            </span>
                          );

                        // 2️⃣ TMM Stage (only after ZSM Approved, and only if NSM hasn't already progressed)
                        if (zsm === "Approved" && tmm === "Pending" && nsm === "Pending")
                          return (
                            <span className="status-pending">
                              Pending (TMM)
                            </span>
                          );
                        if (zsm === "Approved" && tmm === "Rejected")
                          return (
                            <span className="status-rejected">
                              Rework (TMM)
                            </span>
                          );

                        // 3️⃣ NSM Stage (only after TMM Approved, or legacy records where TMM is null but NSM is pending)
                        if ((tmm === "Approved" || (zsm === "Approved" && tmm === "Pending")) && nsm === "Pending")
                          return (
                            <span className="status-pending">
                              Pending (NSM)
                            </span>
                          );
                        if ((tmm === "Approved" || (zsm === "Approved" && tmm === "Pending")) && nsm === "Rejected")
                          return (
                            <span className="status-rejected">
                              Rework (NSM)
                            </span>
                          );

                        // 4️⃣ Completed
                        if (nsm === "Completed")
                          return (
                            <span className="status-approved">Completed</span>
                          );

                        return (
                          <span className="status-approved">Approved</span>
                        );
                      })()}
                    </td>

                    {/* ---------- FEEDBACK BUTTON ---------- */}
                    <td>
                      {(NSM === "Rejected" || ZSM === "Rejected" || TMM === "Rejected") && (
                        <button
                          className="feedback-button"
                          onClick={() => handleShow(index)}
                        >
                          View
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ))}
      <ModalPopup
        isModalOpen={show}
        setIsModalOpen={handleClose}
        ModalMainClass="UpcomigTourDetailsModal"
        backdrop={true}
        fade={false}
        data={
          <>
            {/* ZSM Feedback - visible for BM/SH3 and other users */}
            {(userType === "SH3" || (userType !== "TMM" && userType !== "SH5" && userType !== "SH6")) && (
              <div>
                <h6 style={{ textAlign: "center", marginBottom: "5px" }}>
                  ZSM Feedback
                </h6>
                {zsmfeedback.length > 0 ? (
                  <div>
                    {zsmfeedback.map((item, index) => (
                      <div className="feedbackWrapper" key={index}>
                        <strong className="col-3">{item.key}</strong>:{" "}
                        <p>{item.value}</p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <>
                    <p style={{ textAlign: "center", marginBottom: "10px" }}>
                      Currently No feedback{" "}
                    </p>
                  </>
                )}
              </div>
            )}

            {/* TMM Feedback - visible for ZSM users and other users (not TMM) */}
            {(userType === "SH5" || userType === "SH6" || userType === "SH3" || (userType !== "TMM" && userType !== "SH5" && userType !== "SH6")) && (
              <div>
                <h6 style={{ textAlign: "center", marginBottom: "5px" }}>
                  TMM Feedback
                </h6>
                {tmmfeedback.length > 0 ? (
                  <div>
                    {tmmfeedback.map((item, index) => (
                      <div className="feedbackWrapper" key={index}>
                        <strong className="col-3"></strong>:{" "}
                        <p>{item.value}</p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{ textAlign: "center", marginBottom: "10px" }}>
                    Currently No feedback{" "}
                  </p>
                )}
              </div>
            )}

            {/* NSM Feedback - visible for all users */}
            <div>
              <h6 style={{ textAlign: "center", marginBottom: "5px" }}>
                NSM Feedback
              </h6>
              {feedback.length > 0 ? (
                <div>
                  {feedback.map((item, index) => (
                    <div className="feedbackWrapper" key={index}>
                      <strong className="col-3">{item.key}</strong>:{" "}
                      <p>{item.value}</p>
                    </div>
                  ))}
                </div>
              ) : (
                <p style={{ textAlign: "center", marginBottom: "10px" }}>
                  Currently No feedback{" "}
                </p>
              )}
            </div>
          </>
        }
      />
      <div>
        {/* <Link to={`/DRMplanning`}><FaPlusCircle className="add-button" style={{ fontSize: '10px' }}/></Link> */}
        <Link to={`/DRMplanning`}>
          <button class="plus-button"></button>
        </Link>
      </div>
    </div>
  );
};

export default DRMSummary;
